import { render, staticRenderFns } from "./VeJwCjFreeXsList.vue?vue&type=template&id=4fca92d9&scoped=true"
import script from "./VeJwCjFreeXsList.vue?vue&type=script&lang=js"
export * from "./VeJwCjFreeXsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca92d9",
  null
  
)

export default component.exports